import {
  QConfigPassingCriteriaType,
  type QConfigPassingCriteria,
  type QConfigStructurePassingCriteria,
} from '@exam-management/graphql';

export function formatPassingCriteria(
  criteria: QConfigPassingCriteria | QConfigStructurePassingCriteria,
  fullScore: number,
) {
  const { type, value } = criteria;
  if (type === QConfigPassingCriteriaType.Percent) {
    return `${value}% (${Number(((value / 100) * fullScore).toFixed(2))} คะแนน)`;
  }
  return `${value} คะแนน`;
}
